// Agents Inbox API fns — carved verbatim from `src/features/inbox/api.ts`
// (which now re-exports from here; ARCFE-1051 · D1).
//
// Transport comes from the `@heidi/api` configured-client registry (E5,
// ARCFE-805) — the registry hands back the app's real `scribeHttpV2`
// singleton, same interceptors and same retry/refresh state, so request
// behaviour is byte-identical. The 4.1 P0 measured this module's ONLY boundary
// blocker as `@/utils/scribeHTTP`, and this is that blocker's ratified heal
// (the `coding/clinical-codes` and `session/documents` precedent).
//
// The structural client view keeps axios types out of this package's public
// surface. `paramsSerializer` is typed as axios's OBJECT form on purpose: the
// pre-move call passes `{ indexes: null }`, which is what serialises
// `status: ['pending']` as a repeated `status=pending` key rather than
// `status[0]=pending`. Retyping it as a function would silently change the
// wire format of every list read.
import { getScribeHttpClients } from '@heidi/api/client';
import type { InboxItem, InboxItemsParams, InboxListResponse } from '../../contracts';

interface ScribeHttp {
  get<T>(
    url: string,
    config?: {
      params?: unknown;
      paramsSerializer?: { indexes: null | boolean };
    }
  ): Promise<{ data: T }>;
}

const http = (): ScribeHttp => getScribeHttpClients().scribeHttpV2;

export const fetchInboxItems = async (
  params?: InboxItemsParams
): Promise<InboxListResponse> => {
  const res = await http().get<InboxListResponse>('/inbox/items', {
    params,
    paramsSerializer: {
      indexes: null,
    },
  });
  return res.data;
};

export const fetchInboxItemDetail = async (approvalId: string): Promise<InboxItem> => {
  const res = await http().get<InboxItem>(
    `/inbox/items/${encodeURIComponent(approvalId)}`
  );
  return res.data;
};
